"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCHEDULE_COLUMNS = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _jobsViewsStyles = require("web/shared/jobs/jobsViews.styles.js");
var _cells = require("web/shared/jobs/cells");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* What the schedule shows about each job firing at a given time.
*
* No run columns at all: this is a read of the declarations, and showing a
* last-run beside a declared time would suggest the two are connected when
* one is what should happen and the other is what did.
*/
const SCHEDULE_COLUMNS = exports.SCHEDULE_COLUMNS = [{
  key: "job",
  header: "Job",
  render: job => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.stackedCell)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, (0, _objectSpread2.default)((0, _objectSpread2.default)({
      to: "/internal/jobs/job/".concat(job.jobKey)
    }, stylex.props(_jobsViewsStyles.styles.mono)), {}, {
      children: job.jobKey
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.prose)), {}, {
      children: job.description
    }))]
  }))
}, {
  key: "mode",
  header: "Mode",
  render: job => (0, _cells.mutedPill)(job.executionMode.toLowerCase())
}, {
  key: "retries",
  header: "Retries",
  align: "right",
  render: job => (0, _cells.monoCell)(String(job.maxRetries))
}];